import ListFilters from '@/components/pages/residentialCanteens/mixins/ListFilters'

export default ListFilters
